var _path, _path2, _rect, _g, _path3, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgLockOutlined = function SvgLockOutlined(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 8C0 12.4183 3.58172 16 8 16C12.4183 16 16 12.4183 16 8C16 3.58172 12.4183 0 8 0C3.58172 0 0 3.58172 0 8Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0 8C0 12.4183 3.58172 16 8 16C12.4183 16 16 12.4183 16 8C16 3.58172 12.4183 0 8 0C3.58172 0 0 3.58172 0 8Z",
    fill: "url(#paint0_angular_4684_56545)",
    fillOpacity: 0.32
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_4684_56545",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 3,
    y: 3,
    width: 10,
    height: 10
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 3,
    y: 3,
    width: 10,
    height: 10,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_4684_56545)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.62821 11.9609C5.42108 11.9609 5.24376 11.8871 5.09626 11.7396C4.94875 11.5921 4.875 11.4148 4.875 11.2077V7.29746C4.875 7.09033 4.94875 6.91301 5.09626 6.76551C5.24376 6.618 5.42108 6.54425 5.62821 6.54425H6.125V5.71092C6.125 5.19062 6.30742 4.74806 6.67227 4.38321C7.03712 4.01836 7.4797 3.83594 7.99999 3.83594C8.52028 3.83594 8.96285 4.01836 9.32771 4.38321C9.69255 4.74806 9.87498 5.19062 9.87498 5.71092V6.54425H10.3718C10.5789 6.54425 10.7562 6.618 10.9037 6.76551C11.0512 6.91301 11.125 7.09033 11.125 7.29746V11.2077C11.125 11.4148 11.0512 11.5921 10.9037 11.7396C10.7562 11.8871 10.5789 11.9609 10.3718 11.9609H5.62821ZM7.99999 9.98173C8.20245 9.98173 8.37459 9.91081 8.51641 9.76899C8.65823 9.62717 8.72915 9.45503 8.72915 9.25257C8.72915 9.05011 8.65823 8.87797 8.51641 8.73616C8.37459 8.59433 8.20245 8.52342 7.99999 8.52342C7.79753 8.52342 7.62539 8.59433 7.48357 8.73616C7.34175 8.87797 7.27083 9.05011 7.27083 9.25257C7.27083 9.45503 7.34175 9.62717 7.48357 9.76899C7.62539 9.91081 7.79753 9.98173 7.99999 9.98173ZM6.74999 6.54425H9.24999V5.71092C9.24999 5.36369 9.12846 5.06856 8.88541 4.8255C8.64235 4.58244 8.34721 4.46092 7.99999 4.46092C7.65277 4.46092 7.35763 4.58244 7.11457 4.8255C6.87152 5.06856 6.74999 5.36369 6.74999 5.71092V6.54425Z",
    fill: "black",
    fillOpacity: 0.5
  }))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M7.99929 14.773C4.25882 14.773 1.22656 11.7407 1.22656 8.00027C1.22656 4.25979 4.25882 1.22754 7.99929 1.22754C11.7398 1.22754 14.772 4.25979 14.772 8.00027C14.772 11.7407 11.7398 14.773 7.99929 14.773Z",
    stroke: "black",
    strokeOpacity: 0.2
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_angular_4684_56545",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(7.95092 8) rotate(-44.8248) scale(11.3485 8.71722)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F0F2F5",
    stopOpacity: 0
  })))));
};
export default SvgLockOutlined;